import axios from 'axios'
import qs from 'qs'
import config from '@/config'
import {Message, Loading} from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

class HttpService {
	constructor() {
		this.getCounter = 0
		this.postCounter = 0
		this.loadingInstance = {}
	}
	destroy() {
		if (this.getCounter > 0) {
      if (--this.getCounter == 0) {
        NProgress.done()
      }
		}

		if (this.postCounter > 0) {
      if (--this.postCounter == 0) {
				setTimeout(()=> {
					this.loadingInstance.close()
				}, 1800)
      }			
		}
	}
	merge(customizeConfig) {
		// 请求配置
		let requestConfig = Object.assign({
			baseURL: config.request[process.env.NODE_ENV],
			loading: true
		}, customizeConfig)

		// TOKEN
		const token = {
      token: sessionStorage.getItem(config.tokenName) || ''
    }

		// 请求方法适配
		if (requestConfig.method == 'POST') {
			requestConfig.headers = {}
			requestConfig.headers['Content-Type'] = 'application/x-www-form-urlencoded'
			requestConfig.data = Object.assign(requestConfig.data === undefined ? {} : requestConfig.data, token)
			requestConfig.data = qs.stringify(requestConfig.data)
		} else {
			requestConfig.params = Object.assign(requestConfig.params === undefined ? {} : requestConfig.params, token)
		}

		// 返回最终配置
		return requestConfig
	}
	request(customizeConfig) {
		const requestConfig = this.merge(customizeConfig)
		const httpService = this

		// LOADING
		if (requestConfig.loading) {
			if (requestConfig.method == 'POST') {
        if (this.postCounter == 0) {
          this.loadingInstance = Loading.service({
            fullscreen: true
          })
        }
        this.postCounter++
			} else {
        if (this.getCounter == 0) {
          NProgress.start()
        }
        this.getCounter++	
			}
		}

		return new Promise(resolve => {
			axios(requestConfig).then(res=> {
				// 没消息
				if (res.data.msg == '') {
					resolve(res.data)
				} else {
					Message({
						type: res.data.code == 1 ? 'success' : 'error',
						message: res.data.msg,
						duration: 1800,
						onClose: ()=> {
							resolve(res.data)
						}}
					)
				}

			}).catch(error=> {
				console.warn(error.message)
			}).finally(()=> {
				httpService.destroy()
			})
		})
	}
}

export default new HttpService